export type AdminMenuRow = {
  id: number
  parent_id: number | null
  code: string
  name: string
  path: string
  sort_order: number
}

export function hasAdminMenuAccess(menus: AdminMenuRow[]): boolean {
  return menus.some((m) => m.path)
}

export function canAccessManagePath(menus: AdminMenuRow[], pathname: string): boolean {
  const paths = menus.filter((m) => m.path).map((m) => m.path)
  return paths.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}

export function firstManagePath(menus: AdminMenuRow[]): string | null {
  const leaves = menus.filter((m) => m.path).sort((a, b) => a.sort_order - b.sort_order)
  return leaves[0]?.path ?? null
}
